import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import messages from "res/messages/farsi";

import ICLoading from "res/images/loading.gif";

function LoadingMessage(props) {
    let message = messages.pleaseWait
    if (props.message) {
        message = props.message
    }
    return (
        <Dialog className="groupPack highZIndex_3" open={props.showStatus}>
            <DialogTitle>
                <div className="mediumTextBold center">
                    {message}
                </div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    style={{paddingLeft: "5em", paddingRight: "5em"}}
                    className="center">
                    <img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICLoading}/>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
}

export default LoadingMessage;
